module.exports = __webpack_public_path__ + "media/store/images/bag-16c8b8d175ab106948b20391c9de09bd.svg";